module.exports = __webpack_public_path__ + "static/media/1.ba185e2b.jpg";